import { Navigate } from "react-router"

export const OnlyUnAuthRoute  = ({ auth, children }) => {
  if (auth) {
    return <Navigate to={"/profile"} replace />
  }

  return children
};